import { Box, styled } from "@mui/material";
import { LEDGER_ENVIRONMENTS } from "../../data";
import { useLedgerEnv } from "@/hooks/use-ledger-env";

const Pill = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  backgroundColor: theme.palette.divider,
  borderRadius: 999,
  padding: 4,
  gap: 4,
}));

const Segment = styled("button", {
  shouldForwardProp: (prop) => prop !== "active" && prop !== "tone",
})(({ theme, active, tone }) => ({
  border: "none",
  cursor: "pointer",
  padding: "5px 18px",
  borderRadius: 999,
  fontSize: "0.8rem",
  fontWeight: 600,
  letterSpacing: "0.03em",
  transition: "all 150ms ease",
  color: active ? "#fff" : theme.palette.text.secondary,
  backgroundColor: active
    ? tone === "sandbox"
      ? "#b45309"
      : theme.palette.primary.main
    : "transparent",
}));

const EnvToggle = () => {
  const { environment, setEnvironment } = useLedgerEnv();

  return (
    <Pill role="group" aria-label="Ledger environment">
      <Segment
        type="button"
        active={environment === LEDGER_ENVIRONMENTS.LIVE}
        onClick={() => setEnvironment(LEDGER_ENVIRONMENTS.LIVE)}
      >
        LIVE
      </Segment>
      <Segment
        type="button"
        tone="sandbox"
        active={environment === LEDGER_ENVIRONMENTS.SANDBOX}
        onClick={() => setEnvironment(LEDGER_ENVIRONMENTS.SANDBOX)}
      >
        SANDBOX
      </Segment>
    </Pill>
  );
};

export default EnvToggle;
